import { createContext, useReducer } from "react";

// Crear el contexto con el valor inicial como null

const dftmenu = [
  [["1", "100", "2", "Inicio", "house", "house", false]],
  [
    [
      "1",
      "200",
      "2",
      "Mi Información",
      "contact_emergency",
      "contact_emergency",
      false,
    ],
    [
      ["MiPerfil", "Mi Perfil", "account_circle"],
      ["Cotizaciones", "Cotizaciones", "savings"],
      ["MisDatos", "Instituciones Cotizadas", "business_center"],
    ],
  ],
  [
    ["1", "200", "2", "Mis Solicitudes", "folder", "folder", false],
    [
      ["MisSolicitudes", "Consultar", "folder_shared"],
      ["SeleccionarSolicitud", "Crear Solicitud", "document_scanner"],
    ],
  ],
  [["1", "100", "2", "Buzón", "mail", "mail", false]],
  [["1", "100", "2", "Ubicaciones INJUPEMP", "pin_drop", "pin_drop", false]],
];

export const initialState = {
  token: "",
  id: 0,
  identidad: 0,
  estado: "",
  telefono: "",
  cambiarPw: localStorage.getItem("cambiarPw")
    ? parseInt(localStorage.getItem("cambiarPw"))
    : 0,
  grupo: 0,
  nombre: "NA",
  apellido: "",
  email: "",
  usuario: "",
  foto: "NA",
  access: [],
  CanNot: 0,
  msj: [],
  sessionvariable: [],
  refresh: "",
  path: "",
  canAccessUpdateEmail: false, // Nuevo campo para controlar el acceso a la ruta
};

function getPersistedSessionData() {
  if (typeof window === "undefined") {
    return initialState;
  }

  try {
    const rawAuthData = window.localStorage.getItem("authData");

    if (!rawAuthData) {
      return initialState;
    }

    const parsedAuthData = JSON.parse(rawAuthData);

    if (!parsedAuthData || typeof parsedAuthData !== "object") {
      return initialState;
    }

    return {
      ...initialState,
      ...parsedAuthData,
      token: parsedAuthData.token || "",
      refresh: parsedAuthData.refresh || "",
      access: Array.isArray(parsedAuthData.access)
        ? parsedAuthData.access
        : dftmenu,
      sessionvariable: Array.isArray(parsedAuthData.sessionvariable)
        ? parsedAuthData.sessionvariable
        : [],
      cambiarPw:
        typeof parsedAuthData.cambiarPw !== "undefined"
          ? Number(parsedAuthData.cambiarPw)
          : initialState.cambiarPw,
      canAccessUpdateEmail:
        typeof parsedAuthData.canAccessUpdateEmail === "boolean"
          ? parsedAuthData.canAccessUpdateEmail
          : initialState.canAccessUpdateEmail,
    };
  } catch (error) {
    console.error("Error al restaurar authData:", error);
    return initialState;
  }
}

function reducer(estado, action) {
  let sessidata = { ...estado.sessionData };
  //console.log("Disparando el reducer", action.type);
  switch (action.type) {
    case "SESSION_STAR_DATA":
      sessidata.id = action.payload.UsuarioParticipanteID || 0;
      sessidata.identidad = action.payload.DNI || 0;
      sessidata.estado = action.payload.estado || "NA";
      sessidata.telefono = action.payload.Telefono || "NA";
      sessidata.email = action.payload.Correo || "NA";
      sessidata.nombre = action.payload.NombreCompleto || "NA";
      sessidata.usuario = action.payload.Usuario || "NA";
      sessidata.apellido = action.payload.last_name || "NA";
      sessidata.foto = action.payload.photo || "NA";
      sessidata.access = action.payload.menu || dftmenu;
      sessidata.token = action.payload.token.access;
      sessidata.cambiarPw = action.payload.primer_conexion || 0;
      sessidata.refresh = action.payload.token.refresh || "NULL";
      console.log("SESSION DATA", sessidata);
      return { ...estado, sessionData: sessidata };

    case "CLEAR_SESSION_DATA":
      /*sessidata.id= action.payload.id || 0;
      sessidata.grupo=+action.payload.grupo || 2;
     sessidata.name=action.payload.name ||"NA" ;
      sessidata.foto= action.payload.foto || "NA"; 
      sessidata.CanNot= action.payload.CantNot || 0;
      sessidata.msj=action.payload.msj || [];
      sessidata.flag= action.payload.flag || false; */
      sessidata.id = action.payload.id || 0;
      sessidata.identidad = action.payload.DNI || 0;
      sessidata.telefono = action.payload.Telefono || "NA";
      sessidata.email = action.payload.Correo || "NA";
      sessidata.estado = action.payload.estado || "NA";
      sessidata.nombre = action.payload.NombreCompleto || "NA";
      sessidata.apellido = "NA";
      sessidata.usuario = action.payload.Usuario || "NA";
      sessidata.foto = "NA";
      sessidata.access = dftmenu;
      sessidata.sessionvariable = [];
      sessidata.token = "NA";
      sessidata.refresh = "NULL";
      //console.log("CLEAR SESSION DATA", sessidata);
      return { ...estado, sessionData: sessidata };
    case "SESSION_STAR_ID":
      let newid = estado.id;
      if (newid !== action.payload) {
        newid = action.payload;
      }
      //console.log("ESTADO NUEVO2", estado.id);
      return { ...estado, id: newid };
    case "SET_SESSION_AUTHDATA":
      estado.sessionData = JSON.parse(action.payload);
      return { ...estado };

    case "SET_SESSION_PATH":
      estado.sessionData.path = action.payload;
      //console.log(" PATH GUARDADO", sessidata.path);
      return { ...estado };
    case "CLEAR_SESSION_VARIABLE":
      estado.sessionData.sessionvariable = [];
      return { ...estado };
    // Add more cases for other actions that update your state
    case "UPDATE_CAMBIAR_PW":
      sessidata.cambiarPw = 1;
      localStorage.setItem("cambiarPw", 1); // Persiste el estado en localStorage
      return {
        ...estado,
        sessionData: sessidata,
      };
    case "SET_CAN_ACCESS_UPDATE_EMAIL":
      return {
        ...estado,
        sessionData: {
          ...estado.sessionData,
          canAccessUpdateEmail: action.payload,
        },
      };
    default:
      return { ...estado };
  }
}

export const ContextSession = createContext({
  sessionData: initialState,
  defaultMenu: dftmenu,
  id: "",
  identidad: "",
  estado: "",
  telefono: "",
  ip: "",
  sessionStart: () => {},
  dispatch: () => {},
  storeAuthData: () => {},
  getGrupo: () => {},
  getAuthData: () => {},
  getDataST: () => {},
  clearSession: () => {},
  setPath: () => {},
  setDataAuth: () => {},
  getMenu: () => {},
  getuid: () => {},
  setVariable: () => {},
  clearVariables: () => {},
  getVariable: () => {},
  getToken: () => {},
  getID: () => {},
  setID: () => {},
  ValidateAccess: () => {},
  setCanAccessUpdateEmail: () => {},
});

export default function SessionContextProvider({ children }) {
  const [SessionState, SessionStateDispatch] = useReducer(
    reducer,
    undefined,
    () => ({
      sessionData: getPersistedSessionData(),
      defaultMenu: dftmenu,
    }),
  );
  const currentdate = new Date();

  function setCanAccessUpdateEmail(value) {
    SessionStateDispatch({
      type: "SET_CAN_ACCESS_UPDATE_EMAIL",
      payload: value,
    });
  }

  function setID() {
    const datetime =
      "Last Sync: " +
      currentdate.getDate() +
      "/" +
      (currentdate.getMonth() + 1) +
      "/" +
      currentdate.getFullYear() +
      " @ " +
      currentdate.getHours() +
      ":" +
      currentdate.getMinutes() +
      ":" +
      currentdate.getSeconds();
    //console.log("SE VA CREAR UN NUEVO ID", datetime);
    SessionStateDispatch({
      type: "SESSION_STAR_ID",
      payload: datetime,
    });
  }
  function sessionStart(js) {
    SessionStateDispatch({
      type: "SESSION_STAR_DATA",
      payload: js,
    });
  }
  function setPath(path) {
    //console.log("VAMOS A GUARDAR ESTE PATH", path);
    SessionStateDispatch({
      type: "SET_SESSION_PATH",
      payload: path,
    });
  }
  function setDataAuth() {
    let data = getDataST();
    console.log(data);
    SessionStateDispatch({
      type: "SET_SESSION_AUTHDATA",
      payload: data,
    });
    // console.log('Dede SetData Sesidata', SessionState.sessionData);
  }
  function setVariable(id, data) {
    let flag = true;
    let c = 0;

    SessionState.sessionData.sessionvariable.forEach((element) => {
      for (var key in element) {
        if (key === id) {
          SessionState.sessionData.sessionvariable[c] = { [id]: data };
          //  console.log('Logo encontrael registro', SessionState.sessionData.sessionvariable);
          flag = false;
        }
        c++;
      }
    });
    //console.log('SetVariable', flag, id, data);
    //this.clearStoreAuthData();

    if (flag) SessionState.sessionData.sessionvariable.push({ [id]: data });

    //this.storeAuthData();
    //this.getDataST();
  }

  function getID() {
    return SessionState.id;
  }

  async function storeAuthData() {
    // console.log('Vamos a GUARDAR DATA', SessionState.sessionData, "LOCATION", window.location.pathname);
    let path = window.location.pathname;
    let dat = SessionState.sessionData;
    dat.path = path;
    localStorage.setItem("authData", JSON.stringify(dat));
    // sessionStorage.setItem("authData", JSON.stringify(dat));
    //console.log('DATA GUARDADA', dat);
  }

  function getGrupo() {
    return SessionState.sessionData.grupo;
  }
  function getAuthData() {
    /*console.log("SESSION DATA", SessionState.sessionData.token);*/ return JSON.stringify(
      SessionState.sessionData
    );
  }
  function getDataST() {
    return localStorage.getItem("authData");
  }

  function clearStoreAuthData() {
    localStorage.removeItem("authData");

    SessionStateDispatch({
      type: "CLEAR_SESSION_DATA",
      payload: initialState,
    });
  }

  function getMenu() {
    return [...SessionState.sessionData.access];
  }

  function getuid() {
    return SessionState.sessionData.id;
  }
  function clearVariables() {
    //console.log('fue llamada otra vez');
    SessionState.sessionData.sessionvariable = [];
  }
  function getVariable(id) {
    // console.log('getVariable', id);
    let data;

    SessionState.sessionData.sessionvariable.forEach((element) => {
      for (var key in element) {
        if (key === id) {
          //console.log(id, key);
          data = element[key];
        }
      }
    });
    return data;
  }

  function getToken() {
    return SessionState.sessionData.token;
  }

  function ValidateAccess(acID, subacID, context) {
    let id;
    let subid;
    let url = "";
    let flag = false;
    let suarr = [];
    SessionState.sessionData.access.forEach((el) => {
      if (el.length === 6) {
        id = +el[1];
        if (id === acID) {
          flag = true;
        }
      } else {
        id = +el[0][1];
        suarr = el[1];
        if (suarr.length > 1)
          suarr.forEach((element) => {
            subid = element[3];
            if (subid === subacID) {
              flag = true;
            }
          });
      }
    });
    url = "/" + SessionState.sessionData.access[0][3];
    //if(!flag)this.router.navigateByUrl(context,url);
  }
  const ctxValue = {
    sessionData: SessionState.sessionData,
    ip: "https://be.injupemp.gob.hn:8443", //'http://conectados.injupemp.gob.hn:8080',//"http://172.20.7.10:8080", //
    defaultMenu: SessionState.defaultMenu,
    dispatch: SessionStateDispatch,
    sessionStart: sessionStart,
    storeAuthData: storeAuthData,
    getGrupo: getGrupo,
    getAuthData: getAuthData,
    getDataST: getDataST,
    clearSession: clearStoreAuthData,
    setPath: setPath,
    setDataAuth: setDataAuth,
    getMenu: getMenu,
    getuid: getuid,
    setVariable: setVariable,
    clearVariables: clearVariables,
    getVariable: getVariable,
    getToken: getToken,
    ValidateAccess: ValidateAccess,
    getID: getID,
    setID: setID,
    setCanAccessUpdateEmail: setCanAccessUpdateEmail, // Ahora se expone en el contexto
  };

  return (
    <ContextSession.Provider value={ctxValue}>
      {children}
    </ContextSession.Provider>
  );
}

//Código de JEZER
/*
import { act } from "react";
import { createContext, useReducer } from "react";

// Crear el contexto con el valor inicial como null


const dftmenu =
  [
    [["1", "100", "2", "Inicio", "house", "house", false]],
    [["1", "200", "2", "Mis Solicitudes", "recent_actors", "recent_actors", false], [["MisSolicitudes", "Consultar", "folder_shared"], ["SeleccionarSolicitud", "Crear Solicitud", "document_scanner"]]],
    [["1", "100", "2", "Ubicaciones", "pin_drop", "pin_drop", false]],

  ];


export const initialState = {
  token: "",
  id: 0,
  identidad: 0,
  estado: "",
  cambiarPw: localStorage.getItem('cambiarPw') ? parseInt(localStorage.getItem('cambiarPw')) : 1,
  grupo: 0,
  nombre: "NA",
  apellido: "",
  email: "",
  usuario: "",
  foto: "NA",
  access: [],
  CanNot: 0,
  msj: [],
  sessionvariable: [],
  refresh: "",
  path: ""
};

function reducer(estado, action) {
  let sessidata = { ...estado.sessionData };
  //console.log("Disparando el reducer", action.type);
  switch (action.type) {
    case "SESSION_STAR_DATA":
      console.log("guardando session",action.payload);
      sessidata.id= action.payload.UsuarioParticipanteID || 0;
        sessidata.identidad= action.payload.DNI || 0;
        sessidata.estado=action.payload.estado ||"NA" ;
        sessidata.nombre=action.payload.NombreCompleto ||"NA" ;
        sessidata.usuario=action.payload.Usuario ||"NA" ;
        sessidata.apellido=action.payload.last_name ||"NA" ;
        sessidata.foto= action.payload.photo || "NA"; 
        sessidata.access= action.payload.menu || dftmenu;
       
        sessidata.token=action.payload.token.access ;
        sessidata.cambiarPw=action.payload.primer_conexion || 1;
        sessidata.refresh=action.payload.token.refresh || "NULL";
        console.log("SESSION DATA",sessidata);
        return { ...estado,sessionData:sessidata };

    case "CLEAR_SESSION_DATA":
      sessidata.id = action.payload.id || 0;
      sessidata.identidad = action.payload.DNI || 0;
      sessidata.estado = action.payload.estado || "NA";
      sessidata.nombre = action.payload.NombreCompleto || "NA";
      sessidata.apellido = "NA";
      sessidata.usuario = action.payload.Usuario || "NA";
      sessidata.foto = "NA";
      sessidata.access = dftmenu;
      sessidata.token = "NA";
      sessidata.refresh = "NULL";
      console.log("CLEAR SESSION DATA", sessidata);
      return { ...estado, sessionData: sessidata };
    case "SESSION_STAR_ID":
      let newid = estado.id;
      if (newid !== action.payload);
      newid = action.payload;
      //console.log("ESTADO NUEVO2", estado.id);
      return { ...estado, id: newid };
    case "SET_SESSION_AUTHDATA":
      estado.sessionData = JSON.parse(action.payload);
      return { ...estado };

    case "SET_SESSION_PATH":
      estado.sessionData.path = action.payload;
      //console.log(" PATH GUARDADO", sessidata.path);
      return { ...estado };
    case "CLEAR_SESSION_VARIABLE":
      estado.sessionData.sessionvariable = [];
      return { ...estado };
    // Add more cases for other actions that update your state
    case "UPDATE_CAMBIAR_PW":
      sessidata.cambiarPw = 1;
      localStorage.setItem('cambiarPw', 1); // Persiste el estado en localStorage
      return {
        ...estado,
        sessionData: sessidata
      };
    default:
      return { ...estado };
  }
};


export const ContextSession = createContext({
  sessionData: initialState,
  defaultMenu: dftmenu,
  id: "",
  identidad: "",
  estado: "",
  ip: "",
  sessionStart: () => { },
  dispatch: () => { },
  storeAuthData: () => { },
  getGrupo: () => { },
  getAuthData: () => { },
  getDataST: () => { },
  clearSession: () => { },
  setPath: () => { },
  setDataAuth: () => { },
  getMenu: () => { },
  getuid: () => { },
  setVariable: () => { },
  clearVariables: () => { },
  getVariable: () => { },
  getToken: () => { },
  getID: () => { },
  setID: () => { },
  ValidateAccess: () => { }

});

export default function SessionContextProvider({ children }) {

  const [SessionState, SessionStateDispatch] = useReducer(reducer, { sessionData: initialState, defaultMenu: dftmenu });
  const currentdate = new Date();

  function setID() {
    const datetime = "Last Sync: " + currentdate.getDate() + "/"
      + (currentdate.getMonth() + 1) + "/"
      + currentdate.getFullYear() + " @ "
      + currentdate.getHours() + ":"
      + currentdate.getMinutes() + ":"
      + currentdate.getSeconds();
    //console.log("SE VA CREAR UN NUEVO ID", datetime);
    SessionStateDispatch({
      type: "SESSION_STAR_ID",
      payload: datetime
    });

  }
  function sessionStart(js) {

    SessionStateDispatch({
      type: "SESSION_STAR_DATA",
      payload: js
    });

  }
  function setPath(path) {
    //console.log("VAMOS A GUARDAR ESTE PATH", path);
    SessionStateDispatch({
      type: "SET_SESSION_PATH",
      payload: path
    });
  }
  function setDataAuth() {
    let data = this.getDataST();
   // console.log(data);
    SessionStateDispatch({
      type: "SET_SESSION_AUTHDATA",
      payload: data
    });
   // console.log('Dede SetData Sesidata', SessionState.sessionData);
  }
  function setVariable(id, data) {
    let flag = true;
    let c = 0;

    SessionState.sessionData.sessionvariable.forEach(element => {
      for (var key in element) {

        if (key === id) {
          SessionState.sessionData.sessionvariable[c] = { [id]: data };
        //  console.log('Logo encontrael registro', SessionState.sessionData.sessionvariable);
          flag = false;
        }
        c++;
      }
    });
    //console.log('SetVariable', flag, id, data);
    //this.clearStoreAuthData();

    if (flag)
      SessionState.sessionData.sessionvariable.push({ [id]: data });

    //this.storeAuthData();
    //this.getDataST();
  }


  function getID() {
    return SessionState.id;
  }



  async function storeAuthData() {
   // console.log('Vamos a GUARDAR DATA', SessionState.sessionData, "LOCATION", window.location.pathname);
    let path = window.location.pathname;
    let dat = SessionState.sessionData;
    dat.path = path;
    localStorage.setItem('authData', JSON.stringify(dat));
    //console.log('DATA GUARDADA', dat);

  }

  function getGrupo() { return SessionState.sessionData.grupo; }
  function getAuthData() {  return JSON.stringify(SessionState.sessionData); }
  function getDataST() { return localStorage.getItem('authData'); }

  function clearStoreAuthData() {
    localStorage.removeItem('authData');

    SessionStateDispatch({
      type: "CLEAR_SESSION_DATA",
      payload: initialState
    });

  }

  function getMenu() { return [...SessionState.sessionData.access]; }

  function getuid() { return SessionState.sessionData.id; }
  function clearVariables() {
    //console.log('fue llamada otra vez');
    SessionState.sessionData.sessionvariable = [];
  }
  function getVariable(id) {
    console.log('getVariable', id);
    let data;

    SessionState.sessionData.sessionvariable.forEach(element => {
      for (var key in element) {
        if (key === id) {
          //console.log(id, key);
          data = element[key];
        }
      }
    });
    return data;
  }

  function getToken() { return SessionState.sessionData.token; }

  function ValidateAccess(acID, subacID, context) {
    let id; let subid; let url = "";
    let flag = false; let suarr = [];
    SessionState.sessionData.access.forEach(el => {

      if (el.length === 6) {
        id = +el[1];
        if (id === acID) {
          flag = true;
        }
      } else {

        id = +el[0][1];
        suarr = el[1];
        if (suarr.length > 1)
          suarr.forEach(element => {
            subid = element[3];
            if (subid === subacID) {
              flag = true;
            }
          });
      }
    });
    url = '/' + SessionState.sessionData.access[0][3];
    //if(!flag)this.router.navigateByUrl(context,url);
  }
  const ctxValue = {
    sessionData: SessionState.sessionData,
    ip: 'http://conectados.injupemp.gob.hn:8080/',//"http://172.20.7.10:8080",
    defaultMenu: SessionState.defaultMenu,
    dispatch: () => { },
    sessionStart: sessionStart,
    storeAuthData: storeAuthData,
    getGrupo: getGrupo,
    getAuthData: getAuthData,
    getDataST: getDataST,
    clearSession: clearStoreAuthData,
    setPath: setPath,
    setDataAuth: setDataAuth,
    getMenu: getMenu,
    getuid: getuid,
    setVariable: setVariable,
    clearVariables: clearVariables,
    getVariable: getVariable,
    getToken: getToken,
    ValidateAccess: ValidateAccess,
    getID: getID,
    setID: setID
  }

  return (
    <ContextSession.Provider value={ctxValue}>
      {children}
    </ContextSession.Provider>
  );
}




*/
